import { Component } from "react";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { withErrorBoundary } from "commonComponents/helpers/ErrorBoundary/ErrorBoundary";
import {
    type IBannerAlertProps,
    type IHeaderAlertExtraData,
} from "commonComponents/utilities/HeaderAlerter/HeaderAlerter.types";

export interface IGeneralWarningBannerProps
    extends IBannerAlertProps<IHeaderAlertExtraData | undefined> {
    closable?: boolean;
    onClose?: () => void;
}

class GeneralWarningBannerInternal extends Component<IGeneralWarningBannerProps> {
    static defaultProps = {
        closable: false,
        onClose: () => {},
    };

    render() {
        const { alert, closable, onClose } = this.props;

        // Split the text at new lines, then map each line to a span plus a break and remove the final break
        // The result is JSX with breaks where the original text had new lines
        const alertTextSplit = alert.alertText.split("\n");
        const alertTextWithBreaks = alertTextSplit
            .flatMap((val, index) => [<span key={index}>{val}</span>, <br key={index} />])
            .splice(0, alertTextSplit.length * 2 - 1);

        const alertMessage = (
            <>
                {alertTextWithBreaks}
                {alert.extraData && alertTextSplit[alertTextSplit.length - 1] !== "" && " "}
                {alert.extraData && (
                    <BTExternalLink href={alert.extraData.url} isUnderline>
                        {alert.extraData.linkText}
                    </BTExternalLink>
                )}
            </>
        );

        return (
            <BTAlert
                title={alert.alertTitle}
                message={alertMessage}
                type="warning"
                data-testid="generalWarning"
                closable={closable}
                onClose={onClose}
                banner
            />
        );
    }
}

const GeneralWarningBanner = withErrorBoundary(GeneralWarningBannerInternal)(
    "Could not load General Warning Banner",
);
export default GeneralWarningBanner;
